import { Record, Map } from "immutable"

import { defaultAllTopicTypes } from "../../config/application-definitions"
import { updateCreateModel } from "../model-utils"

export const StudioFilterModel = new Record({
    name: "",
    types: "",
    statuses: "Active"
})

export const defaultStudioSearchFilterModel = new Map({
    name: "",
    types: defaultAllTopicTypes.map(({ name }) => name),
    statuses: "Active"
})

export const updateStudioSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) => updateCreateModel(name, value, searchFilterModel, workingFilterModel)
